import axiosInstance from './axiosInstance';

export const getVerificationCreditProducts = () =>
	axiosInstance.get('/verification-credits/products');

export const getVerificationCreditSummary = (companyId) =>
	axiosInstance.get(`/verification-credits/summary/${companyId}`);

export const createVerificationCreditPaymentIntent = ({ companyId, packKey }) =>
	axiosInstance.post('/verification-credits/payment-intent', { companyId, packKey });

export const confirmVerificationCreditPurchase = ({ companyId, packKey, paymentIntentId }) =>
	axiosInstance.post('/verification-credits/confirm', {
		companyId,
		packKey,
		paymentIntentId,
	});

export const getEmailVerificationLimits = (companyId) =>
	axiosInstance.get('/email-verification/limits', {
		params: companyId ? { companyId } : undefined,
	});

export const updateEmailVerificationProvider = ({ companyId, provider }) =>
	axiosInstance.put('/email-verification/provider-preference', {
		companyId,
		provider,
	});

export const verifyEmailList = ({ companyId, listId, provider }) =>
	axiosInstance.post('/email-verification/verify-list', {
		companyId,
		listId,
		...(provider ? { provider } : {}),
	});

export const verifyEmails = ({ companyId, emails, provider }) =>
	axiosInstance.post('/email-verification/verify', {
		companyId,
		emails,
		...(provider ? { provider } : {}),
	});

export const getVerificationJobs = (companyId, limit = 20) =>
	axiosInstance.get(`/email-verification/jobs/${companyId}`, { params: { limit } });

export const getVerificationJob = (companyId, jobId) =>
	axiosInstance.get(`/email-verification/jobs/${companyId}/${jobId}`);

export const removeVerificationJobContacts = ({
	companyId,
	jobId,
	mode,
	resultIds,
}) =>
	axiosInstance.post(
		`/email-verification/jobs/${companyId}/${jobId}/remove-contacts`,
		{
			mode,
			...(resultIds ? { resultIds } : {}),
		},
	);
